import { Component, Input, AfterViewInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from '@shared/services/shared.service'; 
import { HousingUnitService } from 'app/services/housingunit-service'; 
import { ITreatmentViewModel } from 'app/models/household/treatment'; 
import { DialogAddTreatmentComponent } from './add/add-treatment-dialog'; 
import { AuthService } from '@shared/auth/auth.service';  
 
@Component({
  selector: 'housingunit-treatments',
  templateUrl: './housingunit-treatments.component.html',
  styleUrls: ['./housingunit-treatments.component.scss']
})
export class HousingUnitTreatmentsComponent implements AfterViewInit {
  @Input('housingUnitId')
  housingUnitId: number = 0; 
  @Input('address') 
  address: string = ""; 
  treatmentId: number = 0; 
  processing: boolean = false;
  loading: boolean = false;  
  displayedColumns: string[] = ['treatmentId','statusOfInstall','installedBy','treatmentInstallCompletionDate','latestFilterChangeDate','actions']; 
  dataSource = new MatTableDataSource<ITreatmentViewModel>();
  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort', { static: false}) sort: MatSort; 
  pageSize = 10;
  resultSize: number = 0; 
  treatments: ITreatmentViewModel[] = []; 
 
  filterTable(event: Event) {
    let value = (event.target as HTMLInputElement).value;
    this.dataSource.filter = value.trim().toLowerCase(); 
  }

  constructor(public dialog: MatDialog,
    public housingUnitService: HousingUnitService, 
    public authService: AuthService,
    private toastr: ToastrService,
    private sharedService: SharedService) {
  }

  ngAfterViewInit(): void { 
    this.load();
  }
 
  load() {
    this.loading = true;
    this.housingUnitService.getTreatments(this.housingUnitId).subscribe(
      result => { 
        this.treatments = result; 
        this.dataSource = new MatTableDataSource<ITreatmentViewModel>(result);  
        this.dataSource.sort = this.sort;
        this.resultSize = result.length;
        this.loading = false;    
      },
      error => {
        this.loading = false;
      },
      () => { 
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }

  addTreatment() {  
      const dialogRef = this.dialog.open(DialogAddTreatmentComponent, {
        width: '90%',
        data: {
          treatmentId: 0,
          housingUnitId: this.housingUnitId
        }, 
      });

      /* dialogRef.afterOpened().subscribe(() => {
        const elementToFocus = document.getElementById('btnAddTreatment');
        if (elementToFocus) {
          elementToFocus.blur();
        }
      }); */

      dialogRef.afterClosed().subscribe(result => {
          this.load();
      });
  }
 
  editTreatment(treatmentId: number){
    const dialogRef = this.dialog.open(DialogAddTreatmentComponent, {
      width: '90%',
      data: {
        treatmentId: treatmentId,
        housingUnitId: this.housingUnitId 
      }, 
    });
    dialogRef.afterClosed().subscribe(result => {
      this.load();
    });
  }
 
  deleteTreatment(treatmentId: number) {
    this.sharedService.openConfirm("Are you sure you want to remove this treatment?");
    this.sharedService.confirmed().subscribe(confirmed => {
      if (confirmed) {
        this.processing = true;
        this.housingUnitService.deleteTreatment(treatmentId).subscribe(
          result => {
            this.toastr.success("Treatment Removed");
            this.load();
            this.processing = false;
          },
          error => {
            this.toastr.error("Unable to remove treatment.");
            this.processing = false;
          }
        );
      }
    });
  }
   
}